module.exports = __webpack_public_path__ + "static/media/header-logo.c5d0afd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-logo.png
// module id = 439
// module chunks = 0